import { withStyles } from '@mui/styles';
import React from 'react';
import AbstractDialogTab from '../../base/dialog/components/web/AbstractDialogTab';
import { translate } from '../../base/i18n/functions';
import Checkbox from '../../base/ui/components/web/Checkbox';
import Slider from '../../base/ui/components/web/Slider';
import { inklusivaSettingsStyles } from '../../inklusiva/ui-constants';
import { BRIGHTNESS_SLIDER_MAXIMUM, BRIGHTNESS_SLIDER_MINIMUM, CONTRAST_SLIDER_MAXIMUM, CONTRAST_SLIDER_MINIMUM, OPACITY_SLIDER_MAXIMUM, OPACITY_SLIDER_MINIMUM, SATURATION_SLIDER_MAXIMUM, SATURATION_SLIDER_MINIMUM, ZOOM_SLIDER_MAXIMUM, ZOOM_SLIDER_MINIMUM } from '../../video-menu/constants';
const styles = (theme) => {
    return {
        container: {
            display: 'flex',
            flexDirection: 'column',
            width: '100%'
        },
        headline: {
            marginBottom: theme.spacing(3)
        },
        inputElement: {
            marginBottom: theme.spacing(1),
            fontWeight: 'bold',
            fontSize: ''
        },
        textareaElement: {
            marginBottom: theme.spacing(1)
        },
        description: {
            marginBottom: theme.spacing(3)
        },
        ...inklusivaSettingsStyles(theme)
    };
};
/**
 * React {@code Component} for modifying the user's UI settings.
 */
class UiSettingsTab extends AbstractDialogTab {
    /**
     * Implements React's {@link Component#render()}.
     *
     * @inheritdoc
     * @returns {ReactElement}
     */
    render() {
        const { classes, fontSize, iconSize, visualCues, contrast, brightness, dimming, interpreter, otherParticipants, saturation, screensharing, zoom, t } = this.props;
        const getSizeDescription = (size) => t(`settings.uiSettings.fontSizes.size${size}`);
        return (React.createElement("div", { className: classes.container },
            React.createElement("h2", null,
                " ",
                t('settings.uiSettings.headline'),
                " "),
            React.createElement("p", { className: 'mt-05' },
                " ",
                t('settings.uiSettings.intro'),
                " "),
            React.createElement("div", { className: classes.inputblockContainer },
                React.createElement("h3", null, t('settings.uiSettings.visualcues.headline')),
                React.createElement("p", null,
                    " ",
                    t('settings.uiSettings.visualcues.description'),
                    " "),
                React.createElement(Checkbox, { checked: visualCues, className: classes.inputElement, label: t('settings.uiSettings.visualcues.label'), name: 'visualcues_enable', 
                    // eslint-disable-next-line react/jsx-no-bind
                    onChange: () => super._onChange({
                        visualCues: !visualCues
                    }) })),
            React.createElement("div", { className: classes.inputblockContainer },
                React.createElement("h3", null, t('settings.uiSettings.sizeHeadline')),
                React.createElement("div", { className: classes.controlContainer },
                    React.createElement("div", { className: classes.controlColumn },
                        React.createElement(Slider, { className: classes.inputElement, defaultValue: fontSize, id: 'UI-fontsize-slider', label: t('settings.uiSettings.fontSize'), max: 2, step: 1, min: 0, 
                            // eslint-disable-next-line react/jsx-no-bind
                            onChange: event => super._onChange({
                                fontSize: parseInt(event.target.value, 10)
                            }) })),
                    React.createElement("div", { className: classes.valueColumn }, getSizeDescription(fontSize))),
                React.createElement("div", { className: classes.controlContainer },
                    React.createElement("div", { className: classes.controlColumn },
                        React.createElement(Slider, { className: classes.inputElement, defaultValue: iconSize, id: 'UI-icon-size-slider', label: t('settings.uiSettings.iconSize'), max: 2, step: 1, min: 0, 
                            // eslint-disable-next-line react/jsx-no-bind
                            onChange: event => super._onChange({
                                iconSize: parseInt(event.target.value, 10)
                            }) })),
                    React.createElement("div", { className: classes.valueColumn }, getSizeDescription(iconSize)))),
            React.createElement("div", { className: classes.inputblockContainer },
                React.createElement("h3", { className: 'mt-1' }, t('settings.uiSettings.videoOutput')),
                React.createElement(Checkbox, { checked: otherParticipants, className: classes.inputElement, label: t('settings.userVideo.videoVisibilityEngage'), name: 'video-visibility-toggle', 
                    // eslint-disable-next-line react/jsx-no-bind
                    onChange: () => super._onChange({
                        otherParticipants: !otherParticipants
                    }) })),
            React.createElement("div", { className: classes.inputblockContainer },
                React.createElement("div", { className: classes.controlContainer },
                    React.createElement("div", { className: classes.controlColumn },
                        React.createElement(Slider, { className: classes.inputElement, defaultValue: contrast, id: 'UI-contrast-slider', label: t('settings.userVideo.contrastSliderHeadline'), max: CONTRAST_SLIDER_MAXIMUM, min: CONTRAST_SLIDER_MINIMUM, step: 1, name: 'contrast-slider', 
                            // eslint-disable-next-line react/jsx-no-bind
                            onChange: event => super._onChange({
                                contrast: event.target.value
                            }) })),
                    React.createElement("div", { className: classes.valueColumn },
                        contrast,
                        "%")),
                React.createElement("div", { className: classes.controlContainer },
                    React.createElement("div", { className: classes.controlColumn },
                        React.createElement(Slider, { className: classes.inputElement, defaultValue: brightness, id: 'UI-brightness-slider', label: t('settings.userVideo.brightnessSliderHeadline'), max: BRIGHTNESS_SLIDER_MAXIMUM, min: BRIGHTNESS_SLIDER_MINIMUM, step: 1, name: 'brightness-slider', 
                            // eslint-disable-next-line react/jsx-no-bind
                            onChange: event => super._onChange({
                                brightness: event.target.value
                            }) })),
                    React.createElement("div", { className: classes.valueColumn },
                        brightness,
                        "%")),
                React.createElement("div", { className: classes.controlContainer },
                    React.createElement("div", { className: classes.controlColumn },
                        React.createElement(Slider, { className: classes.inputElement, defaultValue: dimming, id: 'UI-dimming-slider', label: t('settings.userVideo.dimSliderHeadline'), max: OPACITY_SLIDER_MAXIMUM, min: OPACITY_SLIDER_MINIMUM, step: 1, name: 'dimmer-slider', 
                            // eslint-disable-next-line react/jsx-no-bind
                            onChange: event => super._onChange({
                                dimming: event.target.value
                            }) })),
                    React.createElement("div", { className: classes.valueColumn },
                        dimming,
                        "%")),
                React.createElement("div", { className: classes.controlContainer },
                    React.createElement("div", { className: classes.controlColumn },
                        React.createElement(Slider, { className: classes.inputElement, defaultValue: saturation, id: 'UI-saturation-slider', label: t('settings.userVideo.saturationSliderHeadline'), max: SATURATION_SLIDER_MAXIMUM, min: SATURATION_SLIDER_MINIMUM, step: 1, name: 'saturation-slider', 
                            // eslint-disable-next-line react/jsx-no-bind
                            onChange: event => super._onChange({
                                saturation: event.target.value
                            }) })),
                    React.createElement("div", { className: classes.valueColumn },
                        saturation,
                        "%")),
                React.createElement("div", { className: classes.controlContainer },
                    React.createElement("div", { className: classes.controlColumn },
                        React.createElement(Slider, { className: classes.inputElement, defaultValue: zoom, id: 'UI-zoom-slider', label: t('settings.userVideo.zoomSliderHeadline'), max: ZOOM_SLIDER_MAXIMUM, min: ZOOM_SLIDER_MINIMUM, step: 1, name: 'zoom-slider', 
                            // eslint-disable-next-line react/jsx-no-bind
                            onChange: event => super._onChange({
                                zoom: event.target.value
                            }) })),
                    React.createElement("div", { className: classes.valueColumn },
                        zoom,
                        "%")))));
    }
}
export default withStyles(styles)(translate(UiSettingsTab));
